<template>
  <div
    class="pl-6 b-counterparty-list__item"
    @click="chooseCounterparty(item)"
    :class="{'active' : currentCounterparty === item.idInDB}"
  >
    <div class="py-3 b-counterparty-list__item-inner">
      <div class="mb-1 b-counterparty-list__title">{{item.getDisplayNameForList()}}</div>
      <div class="b-counterparty-list__info-wrap">
        <div v-if="item.itn" class="mr-4 b-counterparty-list__info">
          <div class="mr-2 b-counterparty-list__info-name">{{$t('CONTENT.counterparty.itn')}}:</div>
          <div class="b-counterparty-list__info-value">{{item.itn}}</div>
        </div>
        <div v-if="item.rrc" class="b-counterparty-list__info">
          <div class="mr-2 b-counterparty-list__info-name">{{$t('CONTENT.counterparty.rrc')}}:</div>
          <div class="b-counterparty-list__info-value">{{item.rrc}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

	export default {
		props: {
			item: {
				required: true,
        type: Object
			},
    },
    computed: {
      ...mapGetters(['getCurrentCounterpartyIdInDB']),
      currentCounterparty() {
        return this.getCurrentCounterpartyIdInDB;
      }
    },
    methods: {
			chooseCounterparty(item) {
				this.$store.commit('SET_CURRENT_COUNTERPARTY_ID', item.idInDB);
      }
    }
	}
</script>

<style scoped>
</style>
